export const especies = [
    {
        name:"Dorado",
        scientificName:"Salminus brasiliensis",
        length:"Hasta 1 m.",
        diet:"Varía a lo largo de su desarrollo. En su estado adulto es netamente piscívoro.",
        habit:"Especie migratoria. Desove entre mediados de la primavera y verano.",
        manRelation:"Valorado por los pescadores deportivos. Se prohíbe su comercialización en Corrientes y provincias vecinas. Especie utilizada por productores ictícolas.",
        distribution:"Cuencas de los ríos Bermejo, Pilcomayo, Paraná, Uruguay, Paraguay y Río de la Plata.",
        img:"/images/Fauna/2_Especies/fotos/1. Dorado - Salminus brasiliensis.jpg"
    },
    {
        name:"Surubí a lunares",
        scientificName:"Pseudoplatystoma corruscans",
        length:"Hasta 2 m.",
        diet:"Piscívoro. Predador tope.",
        habit:"Hábitos nocturnos. Realiza migraciones reproductivas. Reproducción en ambientes no muy profundos y con buena corriente de agua.",
        manRelation:"Muy valorado por los pescadores comerciales y deportivos.",
        distribution:"Amplia distribución. Cuencas de los ríos Bermejo, Paraná, Paraguay, Uruguay y Río de la Plata.",
        img:"/images/Fauna/2_Especies/fotos/2. Surubi a lunares - Pseudoplatystoma corruscans .jpg"
    },
    {
        name:"Surubí atigrado",
        scientificName:"Pseudoplatystoma reticulatum",
        length:"Hasta 1,5 m.",
        diet:"Piscívoro. Predador tope.",
        habit:"Realiza migraciones reproductivas.",
        manRelation:"Muy valorada por los pescadores comerciales y deportivos. No tan ampliamente distribuida como su congénere Pseudoplatystoma corruscans.",
        distribution:"Amplia distribución. Cuenca de los ríos Paraná, Paraguay y Uruguay.",
        img:"/images/Fauna/2_Especies/fotos/3. Surubi atigrado - Pseudoplatystoma reticulatum .jpg"
    },
    // {
    //     name:"Sábalo",
    //     scientificName:"Prochilodus lineatus",
    //     length:"",
    //     diet:"",
    //     habit:"",
    //     manRelation:"",
    //     distribution:"",
    //     img:"/images/Fauna/2_Especies/fotos/4. Sábalo - Prochilodus lineatus .jpg"
    // },
    // {
    //     name:"Patí",
    //     scientificName:"Luciopimelodus pati",
    //     length:"",
    //     diet:"",
    //     habit:"",
    //     manRelation:"",
    //     distribution:"",
    //     img:"/images/Fauna/2_Especies/fotos/5 Patí - Luciopimelodus pati .jpg"
    // },
    {
        name:"Boga",
        scientificName:"Megaleporinus obtusidens",
        length:"Hasta 58 cm. ",
        weight:"Hasta 4-5 kg.",
        diet:"Omnívoro",
        habit:"",
        manRelation:"Valorada por los pescadores comerciales y recreativos. Especie utilizada por productores ictícolas.",
        distribution:"Cuenca de los ríos Paraná, Uruguay y Río de la Plata.",
        img:"/images/Fauna/2_Especies/fotos/6. Boga - Megaleporinus obtusidens .jpg"
    },
    {
        name:"Armado común",
        scientificName:"Pterodoras granulosus",
        length:"Hasta 70 cm.",
        weight:"Hasta 4,5 kg.",
        diet:"Omnívoro.",
        habit:"Realiza migraciones reproductivas.",
        manRelation:"Posee importancia económica. Los pobladores ribereños lo utilizan en sus dietas como recurso alimenticio.",
        distribution:"Cuenca de los ríos Paraná, Uruguay, Paraguay y Río de la Plata.",
        img:"/images/Fauna/2_Especies/fotos/7. Armado comun - Pterodoras granulosus .jpg"
    },
    // {
    //     name:"Dientudo",
    //     scientificName:"Roeboides descalvadensis",
    //     length:"",
    //     diet:"",
    //     habit:"",
    //     manRelation:"",
    //     distribution:"",
    //     img:"/images/Fauna/2_Especies/fotos/8. Dientudo - Roeboides descalvadensis.jpg"
    // },
    // {
    //     name:"Manguruyú negro",
    //     scientificName:"Zungaro jahu",
    //     length:"",
    //     diet:"",
    //     habit:"",
    //     manRelation:"",
    //     distribution:"",
    //     img:"/images/Fauna/2_Especies/fotos/9. Manguruyú negro - Zungaro jahu .jpg"
    // },
    // {
    //     name:"Manguruyu tape",
    //     scientificName:"Pseudopimelodus mangurus",
    //     length:"",
    //     diet:"",
    //     habit:"",
    //     manRelation:"",
    //     distribution:"",
    //     img:"/images/Fauna/2_Especies/fotos/10. Manguruyu tape - Pseudopimelodus mangurus .jpg"
    // },
    // {
    //     name:"Tararira",
    //     scientificName:"Hoplias malabaricus",
    //     length:"",
    //     diet:"",
    //     habit:"",
    //     manRelation:"",
    //     distribution:"",
    //     img:"/images/Fauna/2_Especies/fotos/11.  Tararira - Hoplias malabaricus.jpg"
    // },
    {
        name:"Salmón de río o pirá pitá",
        scientificName:"Brycon orbignyanus",
        length:"Hasta 60 cm.",
        diet:"Omnívoro.",
        habit:"Especie migratoria. Desovan entre los meses de diciembre y enero. Asociados a ambientes vegetados y sombreados. Suele integrar cardúmenes mixtos con dorados.",
        manRelation:"Valorada por los pescadores deportivos, en particular en la modalidad de pesca con mosca.",
        distribution:"Cuenca de los ríos Paraná, Uruguay y Río de la Plata.",
        img:"/images/Fauna/2_Especies/fotos/13. Salmon de rio o pira pita - Brycon orbignyanus .jpg"
    },
    // {
    //     name:"Corvina de río",
    //     scientificName:"Pachyurus bonariensis",
    //     length:"",
    //     diet:"",
    //     habit:"",
    //     manRelation:"",
    //     distribution:"",
    //     img:"/images/Fauna/2_Especies/fotos/12. Corvina de río - Pachyurus bonariensis.jpg"
    // },
    // {
    //     name:"Palometa",
    //     scientificName:"Pygocentrus nattereri",
    //     length:"",
    //     diet:"",
    //     habit:"",
    //     manRelation:"",
    //     distribution:"",
    //     img:"/images/Fauna/2_Especies/fotos/14. Palometa - Pygocentrus nattereri  .jpg"
    // },
    // {
    //     name:"Morena",
    //     scientificName:"Brachyhypopomus gauderi",
    //     length:"",
    //     diet:"",
    //     habit:"",
    //     manRelation:"",
    //     distribution:"",
    //     img:"/images/Fauna/2_Especies/fotos/15.  Morena - Brachyhypopomus gauderi .jpg"
    // },
    // {
    //     name:"Lenguado de río",
    //     scientificName:"Catathyridium jenynsii",
    //     length:"",
    //     diet:"",
    //     habit:"",
    //     manRelation:"",
    //     distribution:"",
    //     img:"/images/Fauna/2_Especies/fotos/16. Lenguado de río - Catathyridium jenynsii .jpg"
    // },
    // {
    //     name:"Raya",
    //     scientificName:"Potamotrygon brachyura",
    //     length:"",
    //     diet:"",
    //     habit:"",
    //     manRelation:"",
    //     distribution:"",
    //     img:"/images/Fauna/2_Especies/fotos/17. Raya – Potamotrygon brachyura .jpg"
    // },
    // {
    //     name:"Anguila",
    //     scientificName:"Synbranchus marmoratus",
    //     length:"",
    //     diet:"",
    //     habit:"",
    //     manRelation:"",
    //     distribution:"",
    //     img:"/images/Fauna/2_Especies/fotos/18 .Anguila - Synbranchus marmoratus .jpg"
    // },
    // {
    //     name:"Vieja del agua",
    //     scientificName:"Megalancistrus parananus",
    //     length:"",
    //     diet:"",
    //     habit:"",
    //     manRelation:"",
    //     distribution:"",
    //     img:"/images/Fauna/2_Especies/fotos/19. vieja del agua - Megalancistrus parananus .jpg"
    // },
    {
        name:"Bagre Blanco",
        scientificName:"Pimelodus albicans",
        length:"60 cm.",
        diet:"Omnívoro.",
        habit:"Hábitos migratorios. Asociados a fondos fangosos.",
        manRelation:"Posee cierto valor para la pesca comercial. Los pobladores ribereños lo utilizan en sus dietas como recurso alimenticio. Apreciado en la pesca deportiva.",
        distribution:"Cuencas de los ríos Paraguay, Paraná, Uruguay y Río de la Plata.",
        img:"/images/Fauna/2_Especies/fotos/bagre blanco.jpg"
    },
    {
        name:"Bagre Fajado",
        scientificName:"Pimelodus ornatus",
        length:"Hasta 34 cm.",
        diet:"Omnívora.",
        habit:"Especie migratoria. Hábitos alimenticios similares a Pimelodus maculatus.",
        manRelation:"",
        distribution:"Cuencas de los ríos Paraguay y Paraná.",
        img:"/images/Fauna/2_Especies/fotos/Bagre Fajado.jpg"
    },
    {
        name:"Manduré Pico de Pato / Cucharón",
        scientificName:"Sorubim lima",
        length:"Hasta 50 cm.",
        diet:"Se alimentan de invertebrados y pequeños peces.",
        habit:" Especie migratoria. Pez de fondo, nocturno.",
        manRelation:"Los pobladores ribereños lo utilizan en sus dietas como recurso alimenticio.",
        distribution:"Cuencas de los ríos Paraguay, Uruguay, Paraná y Río de la Plata.",
        img:"/images/Fauna/2_Especies/fotos/Mandure-pico-pato.jpg"
    },
    {
        name:"Manduré",
        scientificName:"Ageneiosus militaris",
        length:"40 cm.",
        diet:"Se alimenta preferentemente de peces y crustáceos.",
        habit:"Dimorfismo sexual. Machos con estructuras adaptadas para la cópula. Fecundación interna.",
        manRelation:"Valorada por la calidad de su carne.",
        distribution:"Cuencas de los ríos Uruguay, Paraná y Río de la Plata.",
        img:"/images/Fauna/2_Especies/fotos/Mandure.jpg"
    },
    {
        name:"Manduré Tres Puntos",
        scientificName:"Hemisorubim plathyrhynchos",
        length:"Hasta 50 cm",
        diet:"Invertebrados bentónicos y pequeños peces.",
        habit:"Especie migratoria. Desova entre diciembre y enero aprovechando períodos de inundación. Se lo encuentra en aguas profundas y lentas del río.",
        manRelation:"Apreciado por su carne. Es utilizada para consumo por los pobladores locales.",
        distribution:"Cuenca de los ríos Paraguay y Paraná.",
        img:"/images/Fauna/2_Especies/fotos/mandure-tres-puntos.jpg"
    },
    {
        name:"Pacú",
        scientificName:"Piaractus mesopotamicus",
        length:"Hasta 80 cm",
        weight:'Hasta 20kg.',
        diet:"Omnívoro",
        habit:" En ambientes de agua bien oxigenadas. Especie migratoria. Asciende por los cursos de agua en los meses de otoño y desciende a mediados de primavera.",
        manRelation:"Muy apreciado por su carne y para la pesca recreativa. Especie utilizada por productores ictícolas.",
        distribution:"Río Paraná medio. Río Uruguay medio e inferior. Río Paraguay superior y medio. ",
        img:"/images/Fauna/2_Especies/fotos/Pacu.jpg"
    },
    {
        name:"Bagre amarillo",
        scientificName:"Pimelodus maculatus",
        length:"Hasta 40 cm.",
        diet:"Omnívoro.",
        habit:"Hábitos migratorios. Se reproducen entre noviembre y enero.",
        manRelation:"Posee cierto valor para la pesca comercial. Los pobladores ribereños lo utilizan en sus dietas como recurso alimenticio.",
        distribution:"Ríos Paraguay, Paraná, Uruguay y Río de la Plata. ",
        img:"/images/Fauna/2_Especies/fotos/20. Bagre amarillo -  Pimelodus maculatus .jpg"
    },
]